if (process.env.NODE_ENV === "development")
  window._AMapSecurityConfig = {
    securityJsCode: "b23d4d7b51f782b9f32b2a0e3c586198",
  };
else
  window._AMapSecurityConfig = {
    serviceHost: window.location.origin + "/_AMapService",
  };
